import type { Account } from '@api/hooks/useAccounts';
import { useAccountDetails } from '@api/hooks/useAccounts';
import { useTemplateDetails } from '@hooks/useTemplateDetails';
import type { CreatePaymentTemplate } from 'types/templates';

interface TemplateForPayment {
	isLoading: boolean;
	template?: CreatePaymentTemplate & { uuid: string };
	selectedAccount?: Account;
}

export const useTemplateWithAccount = (templateId?: string): TemplateForPayment => {
	const { data: template, isLoading } = useTemplateDetails(templateId);
	const { data: selectedAccount, isLoading: isAccountLoading } = useAccountDetails(
		template?.account_uuid,
	);

	return templateId
		? { template, isLoading: isLoading || isAccountLoading, selectedAccount }
		: { template, isLoading: false, selectedAccount };
};
